import React, { useEffect } from 'react';

const AddBoxiconsCSS = () => {
  useEffect(() => {
    // Create a new <link> tag
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/boxicons@latest/css/boxicons.min.css';
    
    // Append it to the <head> section
    document.head.appendChild(link);
    
    // Clean up the link when the component is unmounted
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return null;
};

export default AddBoxiconsCSS;
